import gql from 'graphql-tag';

export const UPDATE_INVOICE = gql`
  mutation UpdateInvoice($fieldsObj: UpdateInvoiceInput!, $entityId: ID!, $VOId: ID!) {
    updateInvoice(fieldsObj: $fieldsObj, entityId: $entityId, VOId: $VOId)
  }
`;
